module.exports = __webpack_public_path__ + "assets/tosit-4a5995.svg";